module.exports = __webpack_public_path__ + "media/teacher/components/GetStarted/images/PT G4-8595d05d9df3978a08769d080404292a.gif";